import { Cancel } from '@cegal/ds-icons/dist/Cancel';
import React from 'react';
import { components } from 'react-select';
const ValueRemove = (props) => {
    return (React.createElement(components.MultiValueRemove, Object.assign({}, props),
        React.createElement(Cancel, { style: { cursor: 'pointer' }, size: props.size === 'medium' ? '1.3rem' : '1rem' })));
};
ValueRemove.displayName = 'SelectMultiple.ValueRemove';
export default ValueRemove;
